class ResetPage {
  private requiredInputs: HTMLInputElement[] = [];
  private submitButton: HTMLInputElement | null = null;

  constructor() {
    this._init();
  }

  private _init(): void {
    const resetPage = document.querySelector('.reset');
    if (!resetPage) return;

    this.requiredInputs = Array.from(
      resetPage.querySelectorAll('input[data-reset-required]')
    ) as HTMLInputElement[];
    this.submitButton = resetPage.querySelector(
      'input[name="wp-submit"]'
    ) as HTMLInputElement;

    if (this.requiredInputs.length > 0 && this.submitButton) {
      this._setupEventListeners();
      this._checkInputState();
    }
  }

  private _setupEventListeners(): void {
    this.requiredInputs.forEach((input) => {
      input.addEventListener('input', () => this._checkInputState());
      input.addEventListener('keyup', () => this._checkInputState());
      input.addEventListener('paste', () => {
        setTimeout(() => this._checkInputState(), 10);
      });
    });
  }

  private _checkInputState(): void {
    if (!this.submitButton) return;

    const isEmpty = this.requiredInputs.some((input) => input.value.trim() === '');

    if (isEmpty) {
      this.submitButton.disabled = true;
      this.submitButton.classList.add('disabled');
    } else {
      this.submitButton.disabled = false;
      this.submitButton.classList.remove('disabled');
    }
  }
}

export const resetPage = new ResetPage();
